import { Flex, Heading, Text } from '@radix-ui/themes';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { ReactNode } from 'react';

export const PlotHeader = (props: {
  title: string;
  subtitle: string;
  children: ReactNode;
}) => {
  return (
    <Flex justify="between" align="center" gap="2">
      <Flex direction="column" minHeight="50px">
        <Heading size="4">{props.title}</Heading>

        <Text color={RADIX.COLOR.NEUTRAL} truncate>
          {props.subtitle}
        </Text>
      </Flex>

      {props.children}
    </Flex>
  );
};
